module.exports = __webpack_public_path__ + "static/media/ritlogo.9648cc7b.jpeg";